var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('requisicoes',{attrs:{"dataServicos":_vm.obterDataServicos(),"rotaDetalhar":"Gescon_Gestores_Requisicoes_Detalhar","rotaListagem":"Gescon_Gestores_Requisicoes"}})}
var staticRenderFns = []

export { render, staticRenderFns }